import clsx from 'clsx';
import type { ChoiceCardsProps } from './choiceCards.types';

export function ChoiceCards<T extends string>({ legend, name, value, options, onChange, error, disabled = false, hint }: ChoiceCardsProps<T>) {
    return (
        <fieldset className="space-y-2" disabled={disabled}>
            <legend className="text-sm font-semibold text-raro-gray-800">
                {legend}
                <span className="ml-1 text-rose-600">*</span>
            </legend>
            {hint && <p className="text-xs text-raro-gray-500">{hint}</p>}
            <div className="grid gap-3 sm:grid-cols-2">
                {options.map(option => {
                    const selected = option.value === value;
                    return (
                        <label
                            key={option.value}
                            className={clsx(
                                'flex cursor-pointer items-start gap-3 rounded-xl border px-4 py-3 transition focus-within:outline focus-within:outline-2 focus-within:outline-primary-500',
                                selected ? 'border-primary-500 bg-primary-50' : 'border-raro-gray-200 bg-white hover:border-primary-200',
                                option.disabled && 'cursor-not-allowed opacity-50',
                                disabled && 'cursor-not-allowed opacity-60'
                            )}
                        >
                            <input
                                type="radio"
                                name={name}
                                value={option.value}
                                checked={selected}
                                disabled={option.disabled || disabled}
                                onChange={() => onChange(option.value)}
                                className="mt-1 h-4 w-4 border-raro-gray-300 text-primary-600 focus:ring-primary-500"
                            />
                            <span className="min-w-0">
                                <span className="block text-sm font-semibold text-raro-gray-900">{option.label}</span>
                                {option.description && <span className="mt-0.5 block text-xs text-raro-gray-500">{option.description}</span>}
                            </span>
                        </label>
                    );
                })}
            </div>
            {error && <p className="text-xs text-rose-600" role="alert">{error}</p>}
        </fieldset>
    );
}
